import React from "react";
import {
  Card,
  Row,
  Col,
  Typography,
  Tag,
  Space,
} from "antd";
import {
  EnvironmentOutlined,
  UserOutlined,
  CalendarOutlined,
} from "@ant-design/icons";

const { Title, Text } = Typography;

const statusColors = {
  assigned: "default",
  in_progress: "processing",
  completed: "success",
  cancelled: "error",
  partially_completed: "warning",
};

const RouteHeader = ({ session }) => {
  if (!session) return null;

  const status =
    session.status?.replaceAll("_", " ") || "Assigned";

  return (
    <Card
      style={{
        marginBottom: 16,
        borderRadius: 8,
      }}
      bodyStyle={{
        padding: 18,
      }}
    >
      <Row
        justify="space-between"
        align="top"
        gutter={[12, 12]}
      >
        <Col flex="auto">
          <Title
            level={4}
            style={{
              margin: 0,
              wordBreak: "break-word",
            }}
          >
            {session.route_name}
          </Title>

          <Text type="secondary">
            Delivery Route
          </Text>
        </Col>

        <Col>
          <Tag
            color={
              statusColors[session.status] || "blue"
            }
            style={{
              textTransform: "capitalize",
              fontWeight: 500,
            }}
          >
            {status}
          </Tag>
        </Col>
      </Row>

      <Space
        direction="vertical"
        size={10}
        style={{
          width: "100%",
          marginTop: 20,
        }}
      >
        <Row gutter={8} align="middle">
          <Col>
            <EnvironmentOutlined />
          </Col>

          <Col flex="auto">
            <Text strong>
              Route Code
            </Text>
            <br />
            <Text type="secondary">
              {session.route_code || session.id}
            </Text>
          </Col>
        </Row>

        <Row gutter={8} align="middle">
          <Col>
            <UserOutlined />
          </Col>

          <Col flex="auto">
            <Text strong>
              Driver
            </Text>
            <br />
            <Text type="secondary">
              {session.employee_name || "-"}
            </Text>
          </Col>
        </Row>

        <Row gutter={8} align="middle">
          <Col>
            <CalendarOutlined />
          </Col>

          <Col flex="auto">
            <Text strong>
              Started At
            </Text>
            <br />
            <Text type="secondary">
              {session.started_at || "-"}
            </Text>
          </Col>
        </Row>
      </Space>
    </Card>
  );
};

export default RouteHeader;